// Token & user data management

export const setResidentAuth = (token: string, data: any) => {
    localStorage.setItem("residentToken", token);
    localStorage.setItem("residentData", JSON.stringify(data));
};

export const getResidentToken = (): string | null => {
    return localStorage.getItem("residentToken");
};

export const getResidentData = (): any => {
    const data = localStorage.getItem("residentData");
    return data ? JSON.parse(data) : null;
};

export const isResidentLoggedIn = (): boolean => {
    return !!getResidentToken();
};

export const logoutResident = () => {
    localStorage.removeItem("residentToken");
    localStorage.removeItem("residentData");
    window.location.href = "/resident/login";
};
export const setResidentData = (data: any) => {
    localStorage.setItem("residentData", JSON.stringify(data));
};